import { publicApi } from "./publicApi";

interface DeviceHealthDto {
  deviceId: string;
  deviceName: string;
  deviceAdapterType: string;
  connected: boolean;
  connectionLostTime?: string;
}

export const deviceHealthPublicApi = publicApi.injectEndpoints({
  endpoints: (build) => ({
    getDevicesHealth: build.query<DeviceHealthDto[], void>({
      query: () => ({ url: "/devices/health" })
    })
  })
});

export const { useGetDevicesHealthQuery } = deviceHealthPublicApi;
